/**
 * Groups an array of messages by sender.
 *
 * @template T - The type of messages to group, must extend IGroupableMessage.
 * @param {T[]} messages - The array of messages to group.
 * @returns {IMessageGroup<T>[]} - An array of message groups, where each group contains messages from the same sender.
 * @example
 * const messages = [
 *   { participantId: "user1", timestamp: 1000 },
 *   { participantId: "user1", timestamp: 2000 },
 *   { participantId: "user2", timestamp: 3000 }
 * ];
 * const groups = groupMessagesBySender(messages);
 * // Returns:
 * // [
 * //   {
 * //     senderId: "user1",
 * //     messages: [
 * //       { participantId: "user1", timestamp: 1000 },
 * //       { participantId: "user1", timestamp: 2000 }
 * //     ]
 * //   },
 * //   { senderId: "user2", messages: [{ participantId: "user2", timestamp: 3000 }] }
 * // ]
 */
export function groupMessagesBySender(messages) {
    if (!messages?.length) {
        return [];
    }
    const groups = [];
    let currentGroup = null;
    for (const message of messages) {
        if (!currentGroup || currentGroup.senderId !== message.participantId) {
            currentGroup = {
                messages: [message],
                senderId: message.participantId
            };
            groups.push(currentGroup);
        }
        else {
            currentGroup.messages.push(message);
        }
    }
    return groups;
}
